import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereich-aufgaben-benutzer-berechtigungen-excel';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenFunktionsbereichAufgabenBenutzerBerechtigungenExcelEffects {

    FunktionsbereichAufgabenBenutzerBerechtigungenExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_EXCEL),
        mergeMap((x: ac.GetFunktionsbereichAufgabenBenutzerBerechtigungenExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereichAufgabenBenutzerBerechtigungenExcel(x.funktionsbereich_id).pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereichAufgabenBenutzerBerechtigungenExcelErfolgreichAction(result, x.funktionsbereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereichAufgabenBenutzerBerechtigungenExcelFehlerAction(error, x.funktionsbereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenReportingService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenReportingService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenReportingService);
        }
        return this.service;
    }
}
